module.exports = __webpack_public_path__ + "img/homepage-contact.d564c75f.jpg";